import { Button, Divider, Input, Modal, Popconfirm, Table } from "antd";
import { URL_user_addUser, URL_user_delete_user, URL_user_getAdminUsers, URL_user_getUsers, URL_user_searchUsers, URL_user_setAdmin, requestUrl } from "./Utils/UrlUtils";
import { CSSProperties, useEffect, useState } from "react";
import { MessageInstance } from "antd/es/message/interface";
import { Users } from "./Entity";
import SystemItemSearchView from "./SystemItemSearchView";

interface SystemItemViewProps {
  key_: string
  messageApi: MessageInstance
}

export default (p: SystemItemViewProps) => {

  const [data, setData] = useState<Users[]>([])
  const [total, setTotal] = useState<number>()
  const [page, setPage] = useState<number>(1)
  const [openAddUser, setOpenAddUser] = useState<boolean>(false)
  const [uploadUser, setUploadUser] = useState<Users>({})
  const [loadAddUser, setLoadAddUser] = useState<boolean>(false)

  const [name, setName] = useState<string>()
  const [unit, setUnit] = useState<string>()
  const [phone, setPhone] = useState<string>()
  const [role, setRole] = useState<string>()
  const [type, setType] = useState<number>()
  const [searchLoading, setSearchLoading] = useState<boolean>(false)

  const [isSearch, setIsSearch] = useState<boolean>(false) //目前显示 是搜索列表还是 全部列表

  const styleModel: CSSProperties = {
    padding: 10,
    paddingTop: 5,
    paddingBottom: 5,
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center'
  }
  const clear = () => {
    getUsersList(1)
    setName(undefined)
    setUnit(undefined)
    setPhone(undefined)
    setRole(undefined)
    setType(undefined)
  }
  const columns = [
    {
      title: '姓名',
      dataIndex: 'userName',
      key: 'userName',
      render: (text: any) => <a>{text}</a>,
    },
    {
      title: '单位',
      dataIndex: 'unit',
      key: 'unit',
    },
    {
      title: '电话号码',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '角色',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: '状态',
      dataIndex: 'type',
      key: 'type',
      render: (text: any, record: Users) => (
        <span>{record.type == 2 ? '停用' : '正常'}</span>
      )
    },
    // {
    //   title: '创建时间',
    //   dataIndex: 'createTime',
    //   key: 'createTime',
    // },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: Users) => (
        <span>
          {
            record.role == 'super-admin' ? <></> :
              <Popconfirm
                placement="bottom"
                title={record.role == 'admin' ? '移除管理员' : '设为管理员'}
                // description={description}
                okText="确认"
                cancelText="取消"
                onConfirm={() => {
                  // deleteFile(p.data.id == -1,record.id)
                  setAdmin(record.id)
                }}
              >
                <a style={{ marginLeft: '10px' }}>{record.role == 'admin' ? '移除管理员' : '设为管理员'}</a>
              </Popconfirm>
          }
          <Divider type="vertical" />
          {
            record.role == 'super-admin' ? <></> :
              <Popconfirm
                placement="bottom"
                title={'确认删除？'}
                okText="确认"
                cancelText="取消"
                onConfirm={() => {
                  deleteUser(record.id)
                }}
              >
                <a style={{ marginLeft: '10px' }}>删除</a>
              </Popconfirm>
          }
        </span>
      ),
    },
  ];

  /**
   * 设置管理员
   * @returns 
   */
  const setAdmin = (id?: number) => {
    let body = {
      id: id
    }
    requestUrl({
      url: URL_user_setAdmin,
      method: 'POST',
      body: JSON.stringify(body),
      success: (data: any) => {
        clear()
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally() {

      }
    })
  }

  const deleteUser = (id?: number) => {
    let body = {
      id: id
    }
    requestUrl({
      url: URL_user_delete_user,
      method: 'POST',
      body: JSON.stringify(body),
      success: (data: any) => {
        clear()
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally() {

      }
    })
  }

  /**
   * 获取用户列表
   * @returns 
   */
  const getUsersList = (page: number) => {
    let url = URL_user_getUsers
    if (p.key_ == '1') {
      //所有用户列表
      url = URL_user_getUsers
    } else if (p.key_ == '2') {
      //系统管理员用户列表
      url = URL_user_getAdminUsers
    }
    url += '?page=' + page + '&pageSize=10'
    setIsSearch(false)
    requestUrl({
      url: url,
      method: 'GET',
      success: (data: any) => {
        setData(data.data)
        setTotal(data.total)
        setPage(page)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally() {

      }
    })
  }

  /**
     * 搜索用户列表
     * @returns 
     */
  const searchUsers = (page: number) => {
    if (!name && !unit && !phone && !role && !type) return
    let url = URL_user_searchUsers
    url += '?page=' + page + '&pageSize=10'
    if (name) url += ('&name=' + name)
    if (unit) url += ('&unit=' + unit)
    if (phone) url += ('&phone=' + phone)
    if (role) url += ('&role=' + role)
    if (type) url += ('&type=' + type)
    setIsSearch(true)
    requestUrl({
      url: url,
      method: 'GET',
      success: (data: any) => {
        setData(data.data)
        setTotal(data.total)
        setPage(page)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally() {

      }
    })
  }

  /**
     * 添加用户
     * @returns 
     */
  const addUser = () => {
    setLoadAddUser(true)
    requestUrl({
      url: URL_user_addUser,
      method: 'POST',
      body: JSON.stringify(uploadUser),
      success: (data: any) => {
        clear()
        setOpenAddUser(false)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally() {
        setLoadAddUser(false)
      }
    })
  }

  useEffect(() => {
    clear()
  }, [p.key_])
  const isDisable = (): boolean => {
    if (uploadUser) {
      if (!uploadUser.userName || !uploadUser.phone || !uploadUser.unit) {
        return true
      }
    }
    return false
  }
  return (
    <>
      <SystemItemSearchView
        name={name}
        setName={setName}
        unit={unit}
        setUnit={setUnit}
        phone={phone}
        setPhone={setPhone}
        role={role}
        setRole={setRole}
        type={type}
        setType={setType}
        clear={clear}
        searchLoading={searchLoading}
        searchUsers={() => searchUsers(1)} />
      <div style={{ display: 'flex' }}>
        <Button type="primary" onClick={() => {
          setOpenAddUser(true)
        }}>添加用户</Button>
      </div>
      <Table
        style={{ flex: '1' }}
        onChange={(pagination) => {
          if (isSearch) searchUsers(pagination.current ? pagination.current : 1)
          else getUsersList(pagination.current ? pagination.current : 1)
        }}
        pagination={{ total: total, current: page }}
        columns={columns}
        dataSource={data} />

      <Modal
        open={openAddUser}
        destroyOnClose
        title={"添加用户"}
        maskClosable={false}
        onOk={() => setOpenAddUser(false)}
        onCancel={() => setOpenAddUser(false)}
        afterClose={() => {
          setLoadAddUser(false)
          setUploadUser({})
        }}
        footer={() => (
          <Button
            type="primary"
            onClick={() => addUser()}
            disabled={isDisable()}
            loading={loadAddUser}
          >
            {loadAddUser ? '正在添加' : '添加'}
          </Button>
        )}
      >
        <div style={styleModel}>
          姓&emsp;名：
          <Input
            style={{ flex: 1 }}
            placeholder="请输入姓名"
            value={uploadUser?.userName}
            onChange={(e) => {
              let newO = Object.assign({}, uploadUser)
              newO.userName = e.target.value
              setUploadUser(newO)
            }} />
        </div>
        <div style={styleModel}>
          手机号：
          <Input
            style={{ flex: 1 }}
            placeholder="请输入手机号"
            value={uploadUser?.phone}
            onChange={(e) => {
              let newO = Object.assign({}, uploadUser)
              newO.phone = e.target.value
              setUploadUser(newO)
            }} />
        </div>
        <div style={styleModel}>
          单&emsp;位：
          <Input
            style={{ flex: 1 }}
            placeholder="请输入单位"
            value={uploadUser?.unit}
            onChange={(e) => {
              let newO = Object.assign({}, uploadUser)
              newO.unit = e.target.value
              setUploadUser(newO)
            }} />
        </div>
        {/* <div style={styleModel}>
              姓&emsp;别：
              <Radio.Group  
                onChange={(e)=>{
                  let newO = Object.assign({},uploadUser)
                  newO.sex = e.target.value
                  setUploadUser(newO)
                }} 
                value={uploadUser?.sex}>
                    <Radio value={'男'}>男</Radio>
                    <Radio value={'女'}>女</Radio>
              </Radio.Group>
            </div> */}
        <div style={styleModel}>
          密&emsp;码：默认密码--888888
        </div>
      </Modal>
    </>
  )
}